<template>
  <div class="home_page" id="Media Center Home">
    <Header @search="onSearch" />
    <div class="nav_box" ref="nav">
      <Tab />
    </div>
    <!-- 首页banner -->
    <div class="tacitly" v-if="focus.length == 0" id="Focus News">
      <img src="@/assets/img/homeBanner.png" alt="" />
      <div class="tacitly_text">
        <p>{{ $t('新闻中心') }}</p>
        <p>{{ $t('最新动态、采访资料、服务资讯，供您随时查阅下载') }}</p>
      </div>
      <!-- <div class="bg_text" v-if="focus.length > 0 && focus[0].title != ''">
        <div class="text">
          <p>{{ focus[0].title }}</p>
        </div>
      </div> -->
    </div>
    <div
      class="page_banner"
      id="Focus News"
      v-if="focus.length > 0"
      :class="focus.length <= 1 ? 'hideArrow' : ''"
    >
      <el-carousel trigger="click" height="530px" direction="horizontal">
        <el-carousel-item v-for="(item, index) in focus" :key="index">
          <router-link
            :to="{ name: 'pc_consult', query: { type: 8, id: item.contentId } }"
            :clstag="`newscenter|keycount|home-pc|click-${item.url}`"
            target="_blank"
          >
            <img :src="item.appHeader || ''" alt="" />
            <img
              v-if="focus.length > 0 && focus[0].appHeader == ''"
              src="@/assets/img/homeBanner.png"
              alt=""
            />
          </router-link>
          <div class="bg_text" v-if="focus.length > 1">
            <div class="text">
              <p>
                {{ item.title }}
              </p>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="page_container">
      <!-- 媒体注册按钮 -->
      <div class="layer" ref="layer">
        <p id="newRegistered" class="l_media">
          <a>
            <span
              v-if="!registerShow"
              :title="$t('媒体登录')"
              @click="mediaLogin"
              >{{ $t('媒体登录') }}</span
            >
            <span v-else :title="$t('已登录')">{{ $t('已登录') }}</span>
            <i></i>
          </a>
        </p>
        <p id="ticket" class="l_media l_ticket">
          <a href="https://ticketn-h5.ciftis.org/#/?userToken=v5YaIpuNR3xa6AOT">
            <span>{{ $t('参观购票') }}</span>
            <i></i>
          </a>
        </p>
        <p :title="$t('搜索')" class="l_search">
          <router-link
            to="/search"
            tag="a"
            :clstag="`newscenter|keycount|home-pc|link-search`"
          >
            <span>{{ $t('搜索') }}</span>
            <img src="@/assets/img/layer2.png" alt="" />
          </router-link>
        </p>
        <p
          :title="$t('回到顶部')"
          @click="backTop"
          class="l_top"
          :clstag="`newscenter|keycount|home-PC|link-backTop`"
        >
          <a>
            <span>{{ $t('回到顶部') }}</span>
            <img src="@/assets/img/layer3.png" alt="" />
          </a>
        </p>
      </div>
      <template v-for="(iem, ind) in homeTab">
        <!-- 新闻动态 -->
        <div
          class="newState"
          ref="a"
          :id="'News Trends'"
          v-if="iem.code.includes('News Trends')"
          :key="ind"
        >
          <div class="newHeader">
            <p>{{ iem.name }}</p>
            <router-link
              :to="{ path: '/notice', query: { code: 'News Trends' } }"
              tag="a"
              :clstag="`newscenter|keycount|home-pc|link-News Trends`"
              >{{ $t('查看全部') }} >
            </router-link>
          </div>
          <dl
            v-if="
              iem.code.includes('News Trends') &&
                noticeList[ind] &&
                noticeList[ind].length != 0
            "
          >
            <dt class="no_app">
              <el-carousel
                style="height: 100%"
                height="100%"
                :loop="true"
                :autoplay="true"
                indicator-position="none"
              >
                <el-carousel-item
                  v-for="(item, index) in noticeList[ind].slice(0, 5)"
                  :key="index"
                >
                  <img
                    :src="item.appHeader ? item.appHeader : defaultImg"
                    alt=""
                  />
                  <router-link
                    tag="p"
                    :to="{
                      path: '/consult',
                      query: { id: item.contentId, type: 1 }
                    }"
                  >
                    {{ item.title }}
                  </router-link>
                </el-carousel-item>
              </el-carousel>
            </dt>
            <dd>
              <p
                v-for="(it, idx) in noticeList[ind].slice(5, 10)"
                :key="idx"
                :clstag="`newscenter|keycount|home-pc|link-${it.title}`"
                v-if="idx < 5"
              >
                <a :href="it.url" target="_blank" v-if="it.contentType == 1">
                  <span
                    :title="it.title"
                    :class="{ newColor: it.isMark == 1 }"
                    >{{ it.title }}</span
                  >
                  <b v-if="it.pubTime >= todyTimer"
                    ><img src="@/assets/img/new.png" alt=""
                  /></b>
                  <i>{{ it.pubTime || it.createTime | dataFilter(true) }}</i>
                </a>
                <router-link
                  v-else
                  :to="{
                    path: '/consult',
                    query: { id: it.contentId, type: 1 }
                  }"
                >
                  <span
                    :title="it.title"
                    :class="{ newColor: it.isMark == 1 }"
                    >{{ it.title }}</span
                  >
                  <b v-if="it.pubTime >= todyTimer"
                    ><img src="@/assets/img/new.png" alt=""
                  /></b>
                  <i>{{ it.pubTime || it.createTime | dataFilter(true) }}</i>
                </router-link>
              </p>
            </dd>
          </dl>
          <dl
            v-if="!noticeList[ind] || noticeList[ind].length == 0"
            class="no_make"
          >
            {{ $t('暂无数据') }}
          </dl>
        </div>
        <!-- 活动日历、采访通知 -->
        <div
          class="content_date"
          :id="'Event Agenda'"
          v-if="
            iem.code.includes('Event Agenda') &&
              registerShow != false &&
              user != false
          "
          :key="ind"
        >
          <div class="date_header">
            <p>{{ iem.name }}</p>
            <a href="https://conference-agenda.ciftis.org/activity/info/1"
              >{{ $t('查看全部') }} ></a
            >
          </div>
          <!-- <div class="nowDate">{{ systemDate }}</div> -->
          <div class="date_box">
            <!-- 类别切换 -->
            <ul class="news_forum" ref="news_forum">
              <li
                v-for="(item, index) in classColumns"
                :key="item.id"
                @click="changeForum(item, index)"
              >
                <a
                  :class="{ forum_actives: negotiationType === item.id }"
                  href="javascript:"
                  >{{
                    isEn ? item.topicEnglishName : $t(item.specialTopicName)
                  }}</a
                >
                <p :class="{ forum_active: negotiationType === item.id }"></p>
              </li>
            </ul>
            <!-- 日期切换 -->
            <ul class="tabBtn">
              <li
                v-for="(item, index) in DATE_COLUMNS"
                :key="index"
                @click="changeInd(index, item)"
                :clstag="`newscenter|keycount|home-pc|click-changeIndex`"
              >
                <a
                  :class="{ twice: negotiationDate == item.value }"
                  href="javascript:"
                  >{{ item.label }}</a
                >
              </li>
            </ul>
          </div>
          <p
            style="
              width: 540px;
              height: 1px;
              background: #eee;
              display: block;
              margin: 0 auto;
            "
          ></p>
          <div style="width: 100%; height: 177px; background: #f7f7f7">
            <div
              class="itemTab"
              v-for="(item, index) in meetingList"
              :key="index"
              v-if="index == dataInd && user != false"
              :index="index"
            >
              <p v-if="item.timeSlot">{{ item.timeSlot }} PM</p>
              <p class="name" @click="forumDetail(item)">{{ $t(item.name) }}</p>
              <p>
                <span class="door" v-if="item.doorFlagDesc != ''">{{
                  $t(item.doorFlagDesc)
                }}</span>
                <span class="type" v-if="item.typeValue != ''">{{
                  $t(item.typeValue)
                }}</span>
              </p>
              <div class="date_footer">
                <span v-if="item.meetingRoom != ''">
                  <img src="@/assets/img/wei.png" alt="" />
                  {{ $t(item.meetingRoom) }}
                </span>
                <p>
                  <span
                    @click="subDataInd"
                    :clstag="`newscenter|keycount|home-pc|click-subDataIndex`"
                    >&lt;</span
                  >
                  <span
                    @click="addDataInd"
                    :clstag="`newscenter|keycount|home-pc|click-addDataIndex`"
                    >&gt;</span
                  >
                </p>
              </div>
            </div>
            <div class="dateHint" v-if="!meetingList.length">
              {{ $t('暂无活动/会议安排') }}
            </div>
            <!-- <div
              class="itemTab"
              v-for="(item, index) in special"
              :key="index"
              v-if="
                index == dataInd && user != false && name == 'thematicForum'
              "
              :index="index"
            >
              <p v-if="item.timeSlot">{{ item.timeSlot }} PM</p>
              <p class="name" @click="forumDetails(item)">
                {{ $t(item.name) }}
              </p>
              <p>
                <span class="door" v-if="item.doorFlagDesc != ''">{{
                  $t(item.doorFlagDesc)
                }}</span>
                <span class="type" v-if="item.typeValue != ''">{{
                  $t(item.typeValue)
                }}</span>
              </p>
              <div class="date_footer">
                <span v-if="item.meetingRoom != ''">
                  <img src="@/assets/img/wei.png" alt="" />
                  {{ $t(item.meetingRoom) }}
                </span>
                <p>
                  <span
                    @click="subDataInd"
                    :clstag="`newscenter|keycount|home-pc|click-subDataIndex`"
                    >&lt;</span
                  >
                  <span
                    @click="addDataInd"
                    :clstag="`newscenter|keycount|home-pc|click-addDataIndex`"
                    >&gt;</span
                  >
                </p>
              </div>
            </div> -->
          </div>
        </div>
        <!-- 最新通知 -->
        <div
          class="content_give"
          :id="'Latest Notice'"
          v-if="iem.code.includes('Latest Notice')"
          :key="ind"
        >
          <div class="give_header">
            <p>{{ iem.name }}</p>
            <router-link
              :to="{ path: '/cover', query: { code: 'Latest Notice' } }"
              tag="a"
              :clstag="`newscenter|keycount|home-pc|link-${iem.code}`"
              >{{ $t('查看全部') }} ></router-link
            >
          </div>
          <ul
            class="give_list"
            v-if="
              iem.code.includes('Latest Notice') &&
                noticeList[ind] &&
                noticeList[ind].length > 0
            "
          >
            <router-link
              v-for="(k, index) in noticeList[ind]"
              v-if="index < 3"
              :key="index"
              :to="{ path: '/consult', query: { id: k.contentId, type: 2 } }"
              tag="li"
            >
              <p>
                <span class="listTime">{{ k.pubTime | filDate }}</span>
                <span>{{ k.classification }}</span>
              </p>
              <p :class="{ newColor: k.isMark == 1 }">
                <span>{{ k.title }}</span>
                <b v-if="k.pubTime >= todyTimer"
                  ><img src="@/assets/img/new.png" alt=""
                /></b>
              </p>
            </router-link>
          </ul>
          <ul
            class="no_give"
            v-if="!noticeList[ind] || noticeList[ind].length == 0"
          >
            {{
              $t('暂无数据')
            }}
          </ul>
        </div>
        <!-- 服贸故事 -->
        <div
          class="stories-section"
          :id="'CIFTIS Stories'"
          v-if="iem.code.includes('CIFTIS Stories')"
          :key="ind"
        >
          <div class="stories-header">
            <p>{{ iem.name }}</p>
            <router-link
              :to="{ path: '/stories', query: { code: 'CIFTIS Stories' } }"
              tag="a"
              :clstag="`newscenter|keycount|home-pc|link-${iem.code}`"
              >{{ $t('查看全部') }} >
            </router-link>
          </div>
          <div
            class="stories-list"
            v-if="noticeList[ind] && noticeList[ind].length != 0"
          >
            <p
              v-for="(it, idx) in noticeList[ind]"
              :key="idx"
              :clstag="`newscenter|keycount|home-pc|link-${it.title}`"
              v-if="idx < 4"
            >
              <a :href="it.url" target="_blank" v-if="it.contentType == 1">
                <span :title="it.title" :class="{ newColor: it.isMark == 1 }">{{
                  it.title
                }}</span>
                <b v-if="it.pubTime >= todyTimer"
                  ><img src="@/assets/img/new.png" alt=""
                /></b>
                <i>{{ it.pubTime || it.createTime | dataFilter(true) }}</i>
              </a>
              <router-link
                v-else
                :to="{
                  path: '/consult',
                  query: { id: it.contentId, type: 9 }
                }"
              >
                <span :title="it.title" :class="{ newColor: it.isMark == 1 }">{{
                  it.title
                }}</span>
                <b v-if="it.pubTime >= todyTimer"
                  ><img src="@/assets/img/new.png" alt=""
                /></b>
                <i>{{ it.pubTime || it.createTime | dataFilter(true) }}</i>
              </router-link>
            </p>
          </div>
          <div
            class="no_give"
            v-if="!noticeList[ind] || noticeList[ind].length == 0"
          >
            {{ $t('暂无数据') }}
          </div>
        </div>
        <!-- 预约申请 -->
        <div
          class="time_box"
          :id="'Appointment Applications'"
          v-if="
            iem.code.includes('Appointment Applications') &&
              registerShow != false &&
              user != false
          "
          :key="ind"
        >
          <div class="time_header">
            {{ iem.name }}
            <p></p>
          </div>
          <ul
            class="icon_box"
            v-if="
              iem.code.includes('Appointment Applications') &&
                noticeList[ind] &&
                noticeList[ind].length > 0
            "
          >
            <li
              v-for="(item, index) in noticeList[ind]"
              :key="index"
              @click="time_blank(item)"
              :clstag="`newscenter|keycount|home-pc|click-${item.title}`"
            >
              <a>
                <img
                  v-if="item.appHeader == ''"
                  src="@/assets/img/icon2.png"
                  alt=""
                />
                <img v-else :src="item.appHeader" alt="" />
                <span :title="item.title">{{ item.title }}</span>
              </a>
            </li>
          </ul>
          <ul class="no_make" v-else>
            {{
              $t('暂无数据')
            }}
          </ul>
        </div>
        <!-- 会刊 -->
        <div
          class="media_box"
          :id="'Proceedings'"
          v-if="iem.code.includes('Proceedings')"
          :key="ind"
        >
          <div class="media_header">
            {{ iem.name }}
            <p></p>
          </div>
          <ul
            v-if="
              iem.code.includes('Proceedings') &&
                noticeList[ind] &&
                noticeList[ind].length > 0
            "
          >
            <li
              v-for="(item, index) in noticeList[ind]"
              :key="index"
              v-if="index < 4"
              :clstag="`newscenter|keycount|home-pc|click-${item.title}`"
            >
              <a href="javascript:" @click="_blank(item)">
                <img
                  v-if="item.appHeader == ''"
                  src="@/assets/img/media2.png"
                  alt=""
                />
                <img v-else :src="item.appHeader" alt="" />
                <!-- <div :class="cookieText == 'zh-CN' ? 'mediaTitle' : 'small'">
                  {{ item.title }}
                </div> -->
              </a>
            </li>
          </ul>
          <ul class="no_make" v-else>
            {{
              $t('暂无数据')
            }}
          </ul>
        </div>
        <!-- 媒体服务 -->
        <div
          class="media_box"
          :id="'Media Services'"
          v-if="
            iem.code.includes('Media Services') &&
              registerShow != false &&
              user != false
          "
          :key="ind"
        >
          <div class="media_header">
            {{ iem.name }}
            <p></p>
          </div>
          <ul
            v-if="
              iem.code.includes('Media Services') &&
                noticeList[ind] &&
                noticeList[ind].length > 0
            "
          >
            <li
              v-for="(item, index) in noticeList[ind]"
              :key="index"
              v-if="index < 4"
              :clstag="`newscenter|keycount|home-pc|click-${item.title}`"
            >
              <a href="javascript:" @click="_blank(item)">
                <img
                  v-if="item.appHeader == ''"
                  src="@/assets/img/media2.png"
                  alt=""
                />
                <img v-else :src="item.appHeader" alt="" />
                <div :class="cookieText == 'zh-CN' ? 'mediaTitle' : 'small'">
                  {{ item.title }}
                </div>
              </a>
            </li>
          </ul>
          <ul class="no_make" v-else>
            {{
              $t('暂无数据')
            }}
          </ul>
        </div>
        <!-- 资料中心 -->
        <div
          class="datum_box data-center"
          :id="'Data Center'"
          v-if="iem.code.includes('Data Center')"
          :key="ind"
        >
          <ul
            class="data-list"
            v-if="
              iem.code.includes('Data Center') &&
                noticeList[ind] &&
                noticeList[ind].length > 0
            "
          >
            <li
              class="data-item"
              v-for="(item, index) in noticeList[ind]"
              :key="index"
              v-if="index < 3"
            >
              <a href="javascript:" @click="_blankCenter(item)">
                <img
                  v-if="item.appHeader == ''"
                  src="@/assets/img/moren.png"
                  alt=""
                />
                <img v-else :src="item.appHeader" alt="" />
                <!-- <span>
                  <strong>{{ item.title }}</strong>
                  <i>{{ item.brief }}</i>
                </span> -->
              </a>
            </li>
          </ul>
          <ul class="no_make" v-else>
            {{
              $t('暂无数据')
            }}
          </ul>
        </div>
      </template>
    </div>
    <Footer />
  </div>
</template>

<script>
import '@/assets/css/home.css'
import defaultImg from '@/assets/img/homeNew.png'
import Cookie from 'js-cookie'
import { getHomeList, getNoticeList, getUserApi } from '@/api/news'
import { getUserInfo } from '@/api/registry-api'
import { meetingSchedule, getMeetingTypePid } from '@/api/agenda'
import { formatDate } from '@/utils/formatDate'
import Header from './components/headerBanner'
import Tab from './components/headerTab'
import Footer from './components/footer'
import { getLang } from '@/utils'
import getTranslation from '@/locale/getTranslation'
import { DATE_COLUMNS } from './const.js'

// import { RFC_2822 } from 'moment-timezone'
export default {
  components: {
    Header,
    Tab,
    Footer
  },
  data() {
    return {
      DATE_COLUMNS, // 时间列表
      classColumns: [], // 类别列表
      negotiationDate: DATE_COLUMNS[0].value, // 当前选择日期
      negotiationType: '', // 当前选择类别
      meetingList: [], // 会议日程列表
      Ind: 0,
      defaultImg,
      getLang: getLang(),
      homeTab: [],
      noticeList: [],
      itemCode: [],
      activeDate: [],
      week: [],
      weeks: [],
      keyItem: [],
      data: [],
      dataInd: 0,
      systemDate: '',
      timeZone: '',
      newTime: '',
      todyTimer: '',
      tMonth: '',
      registerShow: false,
      focus: [],
      user: false,
      month: '',
      cookieText: '',
      tab_index: 0,
      isLogin: false,
      notNeedCode: [
        'Focus News',
        'News Trends',
        'Proceedings',
        'Data Center',
        'Latest Notice',
        'CIFTIS Stories'
      ],
      tabCode: '',
      keep: false,
      forum: [
        {
          title: '高峰论坛'
        },
        {
          title: '专题论坛'
        }
      ],
      itemName: [],
      name: '',
      special: [],
      forumInd: 0,
      getCurrentDate: '',
      forumData: {},
      isEn: Cookie.get('ciftis_site_lang') === 'en-US'
    }
  },
  computed: {
    filteredItems: function() {
      return this.noticeList.slice(2, 10)
    }
  },
  watch: {
    isLogin() {
      if (this.isLogin) {
        this.getClassList()
      }
    }
  },
  methods: {
    onSearch(input) {
      this.$router.push({
        name: 'pc_search',
        query: {
          search: input
        }
      })
    },
    async getClassList() {
      let { data } = await getMeetingTypePid(1)
      data = data.filter(item => [5, 19].indexOf(item.id) === -1)
      this.classColumns = data
      this.negotiationType = data[0].id
      await this.getMeetingList()
    },
    async getMeetingList() {
      /* 因后端数据层级错乱，前端临时补救方案（处理现有这么nb的传参方式）！！！
       * #当前数据结构如下
       * 一级：论坛会议   推介洽谈
       * 二级：专题会议/高峰论坛/边会   国别推介洽谈/省区市及港澳台推介洽谈/行业推介洽谈
       * 三级：目前只有(专题会议)有
       * #处理方式
       * 二级的专题会议id传入 prefectureCodes   专题会议的下一级的id传入 twoPrefectureCodes
       * 二级的除了专题会议以外的id传入 twoPrefectureCodes
       * 注意：涉及的页面，会议日程/会议搜索都需要同步修改(pc/h5)
       */

      /*
       * 新闻中心直接调用会议日程列表接口
       * 只展示《专题会议/高峰论坛/边会》数据即可
       *
       */
      let params = {}
      if (this.negotiationType === 4) {
        params = {
          prefectureCodes: this.negotiationType ? [this.negotiationType] : []
        }
      } else {
        params = {
          twoPrefectureCodes: this.negotiationType ? [this.negotiationType] : []
        }
      }
      const { data } = await meetingSchedule(params)
      let newMeetingList = Array.isArray(data) ? data : []
      if (this.negotiationDate === '全部') {
        this.meetingList = newMeetingList
      } else {
        this.meetingList = newMeetingList.filter(item => {
          const time = this.negotiationDate.split('-').join('/')
          return item.meetingDay.includes(time)
        })
      }
    },
    loginCook() {
      this.cookieText = Cookie.get('ciftis_site_lang')
      const ciftis_at = Cookie.get('ciftis_at')
      if (ciftis_at) {
        this.registerShow = true
      } else {
        this.registerShow = false
      }
    },
    async getLoginStatus() {
      let ciftis_at = Cookie.get('ciftis_at')
      if (!ciftis_at) return
      let _data = await getUserInfo()
      if (_data.data && _data.data.userName) {
        this.isLogin = true
      }
      if (_data.data.accountType === 'MEDIA') this.user = true
    },
    async userApi() {
      const ciftis_at = Cookie.get('ciftis_at')
      if (ciftis_at) {
        const res = await getUserApi({
          accountName: Cookie.get('ciftis_account_name')
        })
        if (res.data.accountType === 'MEDIA') this.user = true
      }
    },
    async getTab() {
      const res = await getHomeList()
      this.homeTab = (res && res.result && res.result.data) || []
      setTimeout(() => {
        this.getCode()
      }, 500)
    },
    async getCode() {
      let lang = Cookie.get('ciftis_site_lang')
      let _this = this
      this.homeTab.forEach((item, index) => {
        this.noticeList.push([])

        // 英文状态下取name作为code导致的bug：后台修改英文名称后code对不上导致请求无数据
        // 英文的code是在中文的code后面拼接了数字1，为了保持一致，英文状态下把结尾的1去掉
        let code = lang === 'en-US' ? item.code.replace(/1$/, '') : item.code

        // 预约申请英文名发生变更，导致分类对不上，只能写死
        if (lang === 'en-US' && code === 'Reservation') {
          code = 'Appointment Applications'
        }
        if (
          (!this.isLogin &&
            this.notNeedCode.indexOf(code) >= 0 &&
            !code.includes('Focus News')) ||
          (this.isLogin &&
            !code.includes('Focus News') &&
            !code.includes('Event Agenda'))
        ) {
          getNoticeList({
            cls: code,
            pageNum: '1',
            pageSize: '10'
          }).then(res => {
            let list = res && res.result && res.result.infos
            this.$set(_this.noticeList, index, list)
          })
        }
      })
    },
    //顶部页面
    backTop() {
      document.getElementById('header').scrollIntoView()
    },
    changeInd(i, item) {
      if (this.negotiationDate === item.value) return
      this.dataInd = 0
      this.negotiationDate = item.value
      this.getMeetingList()
    },
    changeForum(item) {
      if (this.negotiationType === item.id) return
      this.dataInd = 0
      this.negotiationType = item.id
      this.getMeetingList()
    },
    //获取当前日期
    getWeek(day) {
      var today = new Date()
      var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day
      today.setTime(targetday_milliseconds)
      var tMonth = today.getMonth()
      var tDate = today.getDate()
      tMonth = this.doHandleMonth(tMonth + 1)
      var weekday = ['Sun', 'Mon', 'Tues', 'Web', 'Thur', 'Fri', 'Sat']
      var date = today.getDay()
      this.weeks.push(weekday[date])
      this.month = tMonth
      return tDate
    },
    doHandleMonth(month) {
      var m = month
      if (month.toString().length == 1) {
        m = '0' + month
      }
      return m
    },
    getDates() {
      var myDate = new Date()
      var month = myDate.getMonth() + 1
      var date = myDate.getDate()
      this.getCurrentDate = month + '/' + date
    },
    //获取日历数据key
    getKey() {
      let data = []
      for (var key in this.activeDate) {
        data.push(key)
      }
      this.keyItem = data
    },
    getkeys() {
      let datas = []
      for (var key in this.activeDate.thematicForum) {
        datas.push(key)
        this.itemName = datas
        this.special = this.activeDate.thematicForum[this.itemName[0]]
      }
    },
    //切换活动日历
    addDataInd() {
      if (this.dataInd >= this.meetingList.length - 1) {
        this.dataInd = this.meetingList.length - 1
      } else {
        this.dataInd++
      }
    },
    subDataInd() {
      if (this.dataInd == 0) {
        this.dataInd = 0
      } else {
        this.dataInd--
      }
    },
    //获取当前年月
    addDate() {
      let nowDate = new Date()
      let date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        date: nowDate.getDate(),
        hh: nowDate.getHours(),
        dd:
          nowDate.getMinutes() < 10
            ? '0' + nowDate.getMinutes()
            : nowDate.getMinutes()
      }
      this.systemDate =
        date.year + getTranslation('年') + 0 + date.month + getTranslation('月')
      this.newTime =
        date.year +
        '-' +
        0 +
        date.month +
        '-' +
        date.date +
        '       ' +
        date.hh +
        ':' +
        date.dd
    },
    newDetail(id) {
      this.$router.push({
        path: '/consult',
        query: {
          id: id,
          type: 1
        }
      })
    },
    timeone() {
      var moment = require('moment-timezone')
      var timezone = moment.tz.guess()
      this.timeZone = timezone
    },
    tab(code, index) {
      var dome = document.getElementById(code)
      this.tab_index = index
      if (!this.user && !dome) {
        this.$router.push({ name: 'web_login' })
      } else {
        window.location.href = '#' + code
      }
    },
    bannerBtn(url) {
      if (url != '') {
        window.open(url)
      }
    },
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop // 滚动条偏移量
      let middle = (document.documentElement.clientHeight - 230) / 2
      if (this.$refs.layer) {
        if (785 - scrollTop <= middle) {
          this.$refs.layer.style = 'position:fixed;top:' + middle + 'px'
        } else {
          this.$refs.layer.style = 'position:absolute;top:785px'
        }
      }
      if (this.$refs.nav) {
        if (scrollTop > 100) {
          this.$refs.nav.style = 'position:fixed;top:0;z-index:999;'
        } else {
          this.$refs.nav.style = ''
        }
      }
    },
    _blank(item) {
      if (item.contentType == 2) {
        this.$router.push({
          path: '/consult',
          query: {
            id: item.contentId,
            type: 3
          }
        })
      } else {
        if (item.url) {
          window.open(item.url)
        }
      }
    },
    _blankCenter(item) {
      if (item.contentType == 2) {
        this.$router.push({
          path: '/consult',
          query: {
            id: item.contentId,
            type: 6
          }
        })
      } else {
        window.open(item.url)
      }
    },
    time_blank(item) {
      if (item.contentType == 2) {
        this.$router.push({
          path: '/consult',
          query: {
            id: item.contentId,
            type: 5
          }
        })
      } else {
        window.open(item.url)
      }
    },
    mediaLogin() {
      this.$router.push({ name: 'web_login' })
    },
    forumDetail(item) {
      window.location.href = `https://conference-agenda.ciftis.org/agenda/detail?id=${item.id}`
    },
    forumDetails(item) {
      window.location.href = `https://conference-agenda.ciftis.org/agenda/detail?id=${item.id}`
    },
    isDomLoad() {
      var _initisDomLoad
      _initisDomLoad = setInterval(() => {
        if (
          this.$refs.news_forum &&
          this.$refs.news_forum.length > 0 &&
          this.activeDate &&
          this.activeDate.thematicForum &&
          Object.keys(this.activeDate.thematicForum).length > 0
        ) {
          clearInterval(_initisDomLoad)
          if (this.getCurrentDate >= '9/6') {
            this.forum[0].title = '专题论坛'
            this.forum[1].title = '高峰论坛'
          } else {
            this.forum[1].title = '专题论坛'
            this.forum[0].title = '高峰论坛'
          }
          if (this.forum[0].title == '专题论坛') {
            this.name = 'thematicForum'
          } else {
            this.name = 'forum'
          }
        }
      }, 500)
    }
  },
  async created() {
    this.getLoginStatus()
    this.getTab()
    this.addDate()
    this.timeone()
    this.loginCook()
    // this.userApi()
    this.getDates()
    window.addEventListener('scroll', this.handleScroll)
    //当前及一周之后的日期
    let data = []
    for (let i = 0; i <= 6; i++) {
      data.push(this.getWeek(+i))
    }
    // var date=data.reverse()
    this.week = data
    // var date = this.week
  },
  async mounted() {
    // let tabCode=this.$route.query.tabCode
    getNoticeList({
      cls: 'Focus News',
      pageNum: '1',
      pageSize: '10'
    }).then(res => {
      this.focus = res && res.result && res.result.infos
    })
    setTimeout(() => {
      if (
        [
          'Appointment Applications',
          'Data Center',
          'Media Services',
          'Proceedings'
        ].includes(this.$route.query.tabCode)
      ) {
        window.location.href = '#' + this.$route.query.tabCode
      }
    }, 500)
    //  this.isDomLoad()
  },
  //转换时间戳&标签
  filters: {
    formatDate(time) {
      let date = new Date(time)
      return formatDate(date, 'yyyy-MM-dd  hh:mm')
    },
    filDate(time) {
      let date = new Date(time)
      return formatDate(date, 'yyyy-MM-dd')
    },
    clssificationFilters(val) {
      if (getLang() == 'en-US') {
        return val
      } else {
        switch (val) {
          case 'Focus News':
            return '焦点新闻'
          case 'News Trends':
            return '新闻动态'
          case 'Conference Notice':
            return '会议通知'
          case 'Press Conference Notice':
            return '发布会通知'
          case 'Appointment Applications':
            return '预约申请'
          case 'Media Services':
            return '媒体服务'
          case 'Data Center':
            return '资料中心'
          default:
            return val
        }
      }
    }
  },
  beforeCreate() {},
  beforeMount() {
    this.todyTimer = new Date().setHours(0, 0, 0, 0)
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  activated() {}
}
</script>
<style scoped lang="scss">
.data-center {
  & > .data-list {
    margin-top: 0;
    height: unset;

    & > .data-item {
      flex: 1;
      height: unset;
    }
  }
}
.stories-section {
  width: 585px;
  float: right;
  padding-top: 60px;
  .stories-header {
    width: 100%;
    height: 48px;
    display: flex;
    justify-content: space-between;
    line-height: 48px;
    color: #373737;
    p:nth-child(1) {
      font-size: 26px;
    }
    p:after {
      content: '';
      width: 35px;
      height: 10px;
      display: block;
      background: #fe8c01;
    }
    a:hover {
      color: #fe8c01;
    }
  }
  .stories-list {
    margin-top: 36px;
    p {
      height: 62px;
      width: 100%;
      border-bottom: 1px solid #eeeeee;
      padding-top: 8px;
      a {
        display: block;
      }
      &:hover {
        color: #fe8c01;
      }
      span {
        display: inline-block;
        max-width: 448px;
        height: 24px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 18px;
      }
      b {
        vertical-align: 4px;
        img {
          display: inline-block;
          width: 30px;
          height: 15px;
          margin-left: 10px;
        }
      }
      i {
        display: block;
        height: 24px;
        line-height: 24px;
        color: #999999;
        font-size: 12px;
      }
    }
  }
}
</style>
